import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as Sentry from '@sentry/browser'
import { Provider } from 'react-redux'
import store from './redux/store'
import { createRoot } from 'react-dom/client'

if (
  window?.location?.href?.includes?.('desktop.claimocity') ||
  window?.location?.href?.includes?.('desktop-ai.claimocity')
) {
  Sentry.init({
    dsn: 'https://BFoFidWyjJLge5Qo9nTwCTK8@s2522491.us-east-9.betterstackdata.com/2522491',
    // To capture performance monitoring data,
    // you must set tracesSampleRate
    tracesSampleRate: 1.0,
  })
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
